import React from 'react';
import { useSearchParams } from 'react-router-dom';

// Query-param addressing: an entity type has a single path (`/spells`). The
// list view renders by default; the detail view renders when a `slug` selector
// param is present (`/spells?slug=fireball&rulebook=...&system=...`); the
// compare view (issue 188) renders when `compare=` names slugs and no `slug`
// selects a single entry (`/spells?compare=fireball,magic-missile`). The
// multiplying axes (system, rulebook) are query params, never path segments —
// so URLs never grow new path segments as systems/editions are added, and a
// comparison is same-Family by construction: the URL names one segment.
export default function EntityRoute({ List, Detail, Compare }) {
  const [params] = useSearchParams();
  if (params.get('slug')) return <Detail />;
  if (Compare && params.get('compare')) return <Compare />;
  return <List />;
}
